import { render, staticRenderFns } from "./fullPreviewErrorState.vue?vue&type=template&id=c215b212&"
import script from "./fullPreviewErrorState.vue?vue&type=script&lang=js&"
export * from "./fullPreviewErrorState.vue?vue&type=script&lang=js&"
import style0 from "./fullPreviewErrorState.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports